export default __webpack_public_path__ + "static/media/blog4.e66d392a.svg";